const call = (fn: (...args: unknown[]) => void) => fn();

export default call;
